import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const SecurityIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="shield" {...props} />;
};

export { SecurityIcon };
